import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { takeLoginNext } from "../../utils/lastProduct";

/**
 * 비로그인 전용 라우트(예: /login) 래퍼 — AuthGuard의 반대.
 * 이미 로그인돼 있으면 /home으로 보내고, 아니면 children을 렌더링한다.
 */
export default function GuestGuard({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "authenticated") {
      navigate(takeLoginNext(), { replace: true });
    }
  }, [status, navigate]);

  if (status !== "unauthenticated") return null;
  return <>{children}</>;
}
